const extractMinutes = (timestamp) => ~~(timestamp / 60000);
const extractDays = (timestamp) => ~~(timestamp / (60000 * 60 * 24));

const typesMap = {
    UserMessage: 'group',
    SystemMessage: 'system',
};

const createChunk = (message, type = typesMap[message.kind]) => {
    if (!type) {
        throw new Error(`Don't know how to handle "${message.kind}" messages`);
    }

    return {
        type,
        base: message,
        messages: [message],
        days: extractDays(message.received),
    };
};

const isDifferentGroup = (stats, message) => {
    if (extractDays(message.received) !== stats.days) {
        return 'date';
    }

    if (
        message.kind !== stats.base.kind ||
        message.author !== stats.base.author ||
        message.destination !== stats.base.destination ||
        extractMinutes(Math.abs(message.received - stats.base.received)) > 0
    ) {
        return true;
    }
};

export const processMessages = function*(allMessages, showInitialDate) {
    let pos = allMessages.length - 1;
    let chunk;
    let message;

    if (showInitialDate && allMessages[pos]) {
        // account for pagination
        yield createChunk(allMessages[pos], 'date');
    }

    while ((message = allMessages[pos])) {
        if (chunk) {
            const differ = isDifferentGroup(chunk, message);

            if (differ) {
                yield chunk;

                if (differ === 'date') {
                    yield createChunk(message, 'date');
                }

                // new group, reset chunk
                chunk = undefined;
            }
        }

        // first iteration of the loop or start of new group
        if (!chunk) {
            chunk = createChunk(message);
        } else {
            chunk.messages.push(message);
        }

        pos--;
    }

    if (chunk) {
        // final chunk
        yield chunk;
    }
};
